import { render } from "./HeaderWidget.vue?vue&type=template&id=4e8a68b9"
import script from "./HeaderWidget.vue?vue&type=script&lang=js"
export * from "./HeaderWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__